export enum TableSelectionType {
    Highlight = 'Highlight',
    Check = 'Check'
}

export enum TableStateType {
    icon = "icon",
    block = "block"
}